<template>
	<div class="home">
		<div class="wrap-container">
			<!-- 技术服务 > 培训服务 > 课程详情 > 课程报名  -->
			<el-breadcrumb class="bread" separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>技术服务</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: `/training_services` }">技术培训</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: `/coursed_details?id=${id}` }"
					>课程详情</el-breadcrumb-item
				>
				<el-breadcrumb-item>课程报名</el-breadcrumb-item>
			</el-breadcrumb>

			<div class="class-info">
				<div class="class-info-title">课程信息</div>
				<div class="class-info-nav">
					<div class="item">课程信息</div>
					<div class="item">授课老师</div>
					<div class="item">课程类型</div>
				</div>
				<div class="class-info-box">
					<div class="info-box-left">
						<div class="box-left-img">
							<img :src="details.banner" alt="" />
						</div>
						<div class="box-left-item">
							<div class="left-item-title">{{ details.title }}</div>
							<div class="left-item-lab">
								开课倒计时：<span class="span_red">{{ timer }}</span>
							</div>
						</div>
					</div>
					<div class="info-box-mid">{{ details.teacher }}</div>
					<div class="info-box-right">
						{{ course_type[details.course_type] }}
					</div>
				</div>
			</div>
			<div class="applicant-info">
				<el-form
					:model="ruleForm"
					:rules="rules"
					ref="ruleForm"
					label-width="100px"
					class="demo-ruleForm"
				>
					<div class="form-title">
						<div class="form-title-left">报名人信息</div>
						<!-- <div class="form-title-right">收起<img style="margin-left: 5px;" src="../image/sq.png" alt=""></div> -->
					</div>
					<el-form-item class="lab-item" size="medium" label="姓名" prop="name">
						<el-input class="lab-form" placeholder="请输入姓名" v-model="ruleForm.name"></el-input>
					</el-form-item>

					<el-form-item class="lab-item" size="medium" label="联系方式" prop="phone">
						<el-input
							class="lab-form"
							placeholder="请输入联系方式"
							v-model="ruleForm.phone"
						></el-input>
					</el-form-item>
					<el-form-item class="lab-item" size="medium" label="岗位名称" prop="job">
						<el-input
							class="lab-form"
							placeholder="请输入岗位名称"
							v-model="ruleForm.job"
						></el-input>
					</el-form-item>

					<el-collapse
						v-model="castoffPuton"
						class="option-scollapse"
						v-if="optional && optional.length > 0"
					>
						<el-collapse-item name="1">
							<template slot="title">
								<div class="form-title">
									<div class="form-title-left">选填项</div>
									<div
										class="form-title-right"
										v-if="castoffPuton.length > 0"
										@click="changeCastoffPuton('1')"
									>
										收起<img style="margin-left: 5px" src="../image/sq.png" alt="" />
									</div>
									<div class="form-title-right" v-else @click="changeCastoffPuton()">
										展开<img style="margin-left: 5px" src="../image/zk.png" alt="" />
									</div>
								</div>
							</template>
							<el-form-item
								class="lab-item"
								size="medium"
								:label="item.name"
								v-for="(item, index) in optional"
								:key="index"
							>
								<el-input
									class="lab-form"
									placeholder="请输入"
									v-model="item.value"
									@input="inputOptional"
								></el-input>
							</el-form-item>
						</el-collapse-item>
					</el-collapse>
					<div class="upload-list">
						<transition-group name="el-zoom-in-top">
							<div class="upload-list-item" v-for="(item, index) in fileList" :key="index">
								<div class="icon">
									<img :src="suffixImg[item.imgIndex].imgName" alt="" />
								</div>
								<div class="name">{{ item.name }}</div>
								<div class="size">({{ (item.size / 1024).toFixed(2) }}k)</div>
								<div class="remove" @click="removeAppendix(item)">删除</div>
								<el-progress
									:status="item.progress && item.progress == 100 ? 'success' : ''"
									class="progress"
									v-if="item.upping"
									:percentage="item.progress"
								></el-progress>
							</div>
						</transition-group>
					</div>
					<el-upload
						class="upload-demo"
						:limit="6"
						:file-list="fileList"
						:multiple="false"
						action=""
						:show-file-list="false"
						:before-upload="onBeforeUpload"
						:auto-upload="false"
						:on-change="handleChangeLoad"
						style="display: flex; align-items: center; margin-left: 20px"
					>
						<el-button size="small" plain class="download-small-btn"
							><img class="download-icon" src="../assets/imgs/shangchuan@2x.png" alt="" />
							<img class="download-icon-hover" src="../assets/icon/sc-bai@2x.png" alt="" />
							点击上传</el-button
						>
						<div style="margin-left: 15px; margin-top: 5px" slot="tip" class="el-upload__tip">
							支持ppt、word、Excel、pdf、zip格式
						</div>
					</el-upload>

					<el-button
						class="submit-btn"
						style="margin-top: 30px; margin-left: 20px; width: 100px"
						type="danger"
						@click="submitForm('ruleForm')"
						>提交</el-button
					>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import {
		$courseCourseRegisterInfo,
		$courseCourseRegister,
		$uploadUploadLarge,
		// 断点续传 分片上传
		$uploadOnlySplitOn,
		// 获取分片上传唯一标识符
		$uploadOnlySplitUpload,
	} from '@/api';
	import { resolve } from 'path';
	import { reject } from 'q';
	export default {
		name: 'Home',
		data() {
			return {
				id: '',
				// 展开收起
				castoffPuton: [],
				// 附件 上传
				fileList: [],
				// 附件后缀
				integratedSuffix: [
					['.pdf'],
					['.ppt', '.pptx'],
					['.doc', '.docx'],
					['.xls', '.xlsx'],
					['.zip', '.rar'],
				],
				// 附件 格式 图片
				suffixImg: {
					0: {
						imgName: require('../assets/icon/PDF@2x.png'),
					},
					1: {
						imgName: require('../assets/icon/PPT@2x.png'),
					},
					2: {
						imgName: require('../assets/icon/word@2x.png'),
					},
					3: {
						imgName: require('../assets/icon/EXCEL@2x.png'),
					},
					4: {
						imgName: require('../assets/icon/RAR@2x.png'),
					},
				},
				// 课程线上 线下
				course_type: ['', '线上', ' 线下'],
				// 详情
				details: {},
				// 选填
				optional: [],
				// 表单
				ruleForm: {
					name: '',
					phone: '',
					job: '',
					appendix: '',
				},
				// 校验 表单
				rules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' },
						{
							min: 2,
							max: 20,
							message: '请输入2~20个字符',
							trigger: ['blur', 'change'],
						},
					],
					phone: [
						{ required: true, message: '请输入手机号', trigger: 'blur' },
						{
							validator: (rule, value, callback) => {
								const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
								if (value.length < 11 || !reg.test(value)) {
									callback(new Error('手机号格式不正确'));
								} else {
									callback();
								}
							},
							trigger: 'blur',
						},
					],
					job: [{ required: true, message: '请输入岗位名称', trigger: 'blur' }],
				},
				timer: '',
				showTime: '',
			};
		},
		computed: {
			//计算属性
		},
		components: {},
		destroyed() {},
		mounted() {
			let { id } = this.$route.query;
			if (!id) {
				this.$alert('未选择报名课程', '系统提示', {
					confirmButtonText: '确定',
					callback: (action) => {
						this.$router.go(-1);
					},
				});
				return;
			}
			this.id = id;
			this.getInfo(this.id);
		},
		methods: {
			inputOptional(val) {
				// console.log(this.optional);
				// console.log(val);
			},
			onBeforeUpload(val) {
				// console.log("onBeforeUpload", val);
			},
			changeCastoffPuton(val) {
				if (val) {
					this.castoffPuton = [val];
				} else {
					this.castoffPuton = [];
				}
			},
			//  点击文件列表中已上传的文件时的钩子
			handlePreview(val) {
				// console.log("handlePreview", val);
			},
			// 文件列表移除文件时的钩子
			handleRemove(val) {
				// console.log(val);
			},
			// 删除文件之前的钩子
			beforeRemove(val) {
				// console.log(val);
			},
			handleExceed(val) {
				// console.log(val);
			},
			// 添加 附件
			handleChangeLoad(val, valList) {
				// console.log(val);
				/**
				 * 单文件上传
				 */
				// 后缀名

				if (
					this.fileList.find((item) => {
						return item.name == val.name;
					})
				) {
					this.$message.error(`已有同名文件`);
					return;
				}

				// 文件大于1G 不让上传
				if (val.size > 1024 ** 3) {
					allow = false;
					this.$message.error(`单个文件过大，请分多成多个文件上传`);
					return;
				}

				let lastSuffix = this.getSuffix(val.name);
				let allow = false;
				this.integratedSuffix.forEach((item, i) => {
					if (item.indexOf(lastSuffix) != -1) {
						val.imgIndex = i;
						val.progress = 0;
						val.upping = false;
						allow = true;
					}
				});
				if (allow) {
					this.fileList.push(val);
				} else {
					this.$message.error(`不支持上传${lastSuffix}格式的文件`);
				}

				//////////////////
				/**
				 * 多文件选择
				 */
				// let addList = [];
				// let prohibitList = [];
				// valList.forEach((item, index) => {
				//   let lastSuffix = this.getSuffix(item.name);
				//   let allow = false;
				//   this.integratedSuffix.forEach((key, i) => {
				//     if (key.indexOf(lastSuffix) != -1) {
				//       item.imgIndex = i;
				//       addList.push(item);
				//       allow = true;
				//     }
				//   });
				//   if (!allow) {
				//     valList.splice(index, 1);
				//     prohibitList.push(lastSuffix);
				//   }
				// });
				// if (prohibitList.length > 0) {
				//   this.$message.error(`不支持上传${prohibitList.join(",")}格式的文件`);
				// }
				// this.fileList = addList;
				// console.log(this.fileList);
			},
			// 删除已添加的附件
			removeAppendix(item) {
				let indexs = this.fileList.indexOf(item);
				if (indexs != -1) {
					this.fileList.splice(indexs, 1);
				}
			},
			// 获取 后缀名
			getSuffix(name) {
				return name.substring(name.lastIndexOf('.'));
			},
			getInfo(id) {
				$courseCourseRegisterInfo({
					course_id: id,
				}).then((res) => {
					if (res) {
						this.details = res.data;
						this.optional = res.data.additional;

						this.showTime = setInterval(() => {
							let class_time = res.data.class_time;
							if (new Date().getTime() >= res.data.class_time * 1000) {
								clearInterval(this.showTime);
								this.timer = '已开课';
							} else {
								this.timer = this.timeOld(new Date(), class_time);
							}
						}, 1000);
					}
				});
			},
			// 提交
			submitForm(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let parmas = {
							course_id: this.id,
							name: this.ruleForm.name,
							contact_details: this.ruleForm.phone,
							post: this.ruleForm.job,
							appendix: '',
							additionals: JSON.stringify(this.optional),
						};

						if (this.fileList.length > 0) {
							const loading = this.$loading({
								lock: true,
								text: '正在上传附件',
								spinner: 'el-icon-loading',
								background: 'rgba(0, 0, 0, 0.7)',
							});
							let resultImg = await this.uploadImage();
							try {
								let imgStrList = [];
								resultImg.forEach((item) => {
									if (item.data && item.code == 200) {
										imgStrList.push(item.data.url);
									} else {
										this.$message({
											message: `${item.dev_name}上传异常`,
											type: 'error',
											showClose: true,
										});
									}
								});
								parmas.appendix = imgStrList.join(',');
							} catch (error) {}
							loading.close();
						}
						const loadingSubmit = this.$loading({
							lock: true,
							text: '正在提交',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)',
						});
						// 报名 提交
						$courseCourseRegister(parmas)
							.then((res) => {
								loadingSubmit.close();
								if (res) {
									this.$alert('报名成功', '系统提示', {
										confirmButtonText: '确定',
										callback: (action) => {
											this.$router.go(-1);
										},
									});
								} else {
									this.$message.error({
										message: `提交失败,请稍后再试`,
										showClose: true,
									});
								}
							})
							.catch((err) => {
								console.log(err);
								loadingSubmit.close();
								this.$message.error({
									message: `提交失败,请稍后再试`,
									showClose: true,
								});
							});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			uploadImage() {
				let imgGroup = [...this.fileList];
				return new Promise((resolve, reject) => {
					Promise.all(
						imgGroup.map((item, index) => {
							if (item.size > 1024 * 1024 * 100) {
								// 分片上传
								return this.uploadOnlySplit(item.raw, 1024 * 1024 * 5, index, (ing, i, total) => {
									let complete = parseInt((i / total) * 100);
									this.fileList[index].upping = true;
									this.fileList[index].progress = complete;
									this.$forceUpdate();
								});
							} else {
								// 一般大文件上传
								return this.uploadSmallFile(item.raw, index, (ing) => {
									let complete = parseInt((ing.loaded / ing.total) * 100);
									this.fileList[index].upping = true;
									this.fileList[index].progress = complete;
									this.$forceUpdate();
									// console.log(item.name, complete);
								});
							}
						})
					)
						.then((res) => {
							resolve(res);
						})
						.catch((err) => {
							reject(err);
						});
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},

			// 大文件上传
			async uploadOnlySplit(file, sliceLength = 1024 * 1024 * 5, turn, uploadCallback) {
				// 请求标识符
				let uploadOn = await $uploadOnlySplitOn({
					file_name: file.name,
					size: file.size, // 文件总大小
					suffix: file.name.getSuffix(),
				});
				// 使用进一法，来确定分片的个数
				let total_number = Math.ceil(file.size / sliceLength);
				// 分片的初始位置
				let start = 0;
				// 分片的结束位置
				let end = sliceLength;
				// 这里为promise.all方法准备一个数组
				let requset_file = null;

				for (let i = 1; i <= total_number; i++) {
					// 这里开始分片，并且把每一个分片上传到服务器
					// File{}
					//[0,0,1,0,1,2,3,4,5,5,2]
					let blob = file.slice(start, end); // 得到一个分片
					let formData = await new FormData(); // 创建一个FormData对象，准备传送数据
					await formData.append('file', blob); // formData
					await formData.append('uploadId', uploadOn.data.uploadId); // 同时为这个分片设置一个名称，其中的i帮助后端进行排序处理
					// formData组装好之后，调用pro()函数，返回一个promise对象，并把它放入parr数组中，方便后面的promise.all方法使用
					await formData.append('OSS_SEEK_TO', start);
					await formData.append('OSS_LENGTH', end);
					await formData.append('batch', i);
					if (i == total_number) {
						await formData.append('isuploadEnd', true);
					}
					start = end; // 调整下一个分片的起始位置
					end = start + sliceLength; // 调整下一个分片的结束位置
					if (end > file.size) {
						end = file.size; // 这里对最后的一个分片结束位置进行调整
					}

					// 打印 上传 formData数据
					// for (var value of formData.values()) {
					//   console.log(value);
					// }
					uploadCallback(null, i, total_number);
					try {
						// 处理 并发问题 以及 传输顺序
						let result = await $uploadOnlySplitUpload({
							formData,
							onUploadProgress: (progressEvent) => {},
						});

						result.dev_name = file.name;
						if (typeof result == 'object' && i == total_number && result.code == 200) {
							requset_file = result;
						}
					} catch (error) {}
				}
				return new Promise((resolve, reject) => {
					resolve(requset_file);
				});
			},

			// 小文件上传
			uploadSmallFile(file, turn, uploadCallback) {
				let param = new FormData();
				param.append('file', file);
				return new Promise((resolve, reject) => {
					$uploadUploadLarge({
						formData: param,
						onUploadProgress: (progressEvent) => {
							uploadCallback(progressEvent);
						},
					})
						.then((res) => {
							res.dev_name = file.name;
							resolve(res);
						})
						.catch((err) => {
							err.dev_name = file.name;
							reject(err);
						});
				});
			},
			timeOld(nowTime, time) {
				if (time) {
					var nowtime = new Date(), //获取当前时间
						endtime = time * 1000; //定义结束时间
					var lefttime = endtime - nowtime.getTime(), //距离结束时间的毫秒数
						leftd = Math.floor(lefttime / (1000 * 60 * 60 * 24)), //计算天数
						lefth = Math.floor((lefttime / (1000 * 60 * 60)) % 24), //计算小时数
						leftm = Math.floor((lefttime / (1000 * 60)) % 60), //计算分钟数
						lefts = Math.floor((lefttime / 1000) % 60); //计算秒数
					return leftd + '天' + lefth + '小时' + leftm + '分钟' + lefts + '秒'; //返回倒计时的字符串
				} else {
					return ' 00 天 00 小时 00 分钟 00 秒'; //返回倒计时的字符串
				}
			},
		},
	};
	// var suffix = name.substring(name.lastIndexOf("."));
</script>
<style lang="scss" scoped>
	.wrap-container {
		position: relative;
		box-sizing: border-box;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
		background-color: #f5f5f5;

		.upload-demo {
			.download-icon-hover {
				display: none;
			}

			button:hover {
				background-color: #e60000 !important;
				color: #fff !important;

				.download-icon {
					display: none;
				}
				.download-icon-hover {
					display: inline-block;
				}
			}
		}

		.download-icon-hover,
		.download-icon {
			position: relative;
			top: -1px;
			width: 14px;
			height: 14px;
		}
		.bread {
			margin: calc(var(--proportion) * 40px) calc(var(--proportion) * 160px);
			margin-left: 10%;
		}
		.class-info {
			background-color: #fff;
			width: 75%;
			margin-left: 12.5%;
			padding: 2%;
			&-title {
				font-size: 18px;

				font-weight: bold;
				color: #333333;
				margin-bottom: 32px;
			}
			&-nav {
				display: flex;
				justify-content: space-around;
				text-align: center;
				border: 1px solid #eeeeee;
				background: #f5f5f5;
				font-size: 14px;

				font-weight: 400;
				height: 48px;
				line-height: 48px;
				color: #666666;
				.item {
					width: 20%;
				}
				.item:first-child {
					flex: 1;
				}
			}
			&-box {
				display: flex;
				justify-content: space-around;
				text-align: center;
				border: 1px solid #eeeeee;
				padding: 21px;
				align-items: center;
				.info-box-left {
					display: flex;
					flex: 1;
					.box-left-img {
						width: 200px;
						height: 92px;
						img {
							width: 100%;
							object-fit: cover;

							height: 100%;
						}
					}
					.box-left-item {
						text-align: start;
						margin-left: 25px;
						.left-item-title {
							font-size: 20px;

							font-weight: bold;
							margin-top: 10px;
							color: #333333;
						}
						.left-item-lab {
							font-size: 16px;

							margin-top: 16px;
							font-weight: 400;
							color: #333333;
							line-height: 28px;
						}
					}
				}
				.info-box-mid {
					width: 20%;
					font-size: 16px;

					font-weight: 400;
				}
				.info-box-right {
					width: 20%;
					font-size: 16px;

					font-weight: 400;
				}
			}
		}

		.applicant-info {
			background-color: #fff;
			width: 75%;
			margin-left: 12.5%;
			padding: 2%;
			margin-top: 20px;
			margin-bottom: 65px;
			.demo-ruleForm {
				.lab-item {
					margin-bottom: 20px;
					.lab-form {
						width: 480px;
						height: 42px;
						// background: #f5f5f5;
						border-radius: 2px;
					}
				}
				.form-title {
					width: 546px;
					height: 42px;
					display: flex;
					justify-content: space-between;
					margin-left: 23px;
					&-left {
						font-size: 16px;

						font-weight: bold;
						color: #333333;
					}
					&-right {
						cursor: pointer;
						font-size: 14px;

						font-weight: 400;

						color: #3094e0;
					}
				}
			}
		}
	}
	::v-deep .el-form-item__label::before {
		content: '' !important;
		margin-right: 0px;
	}
	::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
		content: '*';
		color: #f56c6c;
		margin-left: 6px;
	}
	::v-deep .el-collapse {
		border-top: 0px;
		border-bottom: 0px;
	}
	::v-deep .el-collapse-item__wrap {
		border-bottom: 0px;
	}
	::v-deep .el-collapse-item__header {
		border-bottom: 0px;
		.el-icon-arrow-right:before {
			opacity: 0;
		}
	}
	.option-scollapse {
		width: 600px;
	}
	.upload-list {
		padding: 10px 0px;
	}
	.upload-list-item:hover {
		.remove {
			display: inline-block;
		}
	}
	.upload-list-item {
		position: relative;
		box-sizing: border-box;
		padding: 3px 0px;
		width: 540px;
		height: 40px;
		display: flex;
		align-items: center;

		.progress {
			position: absolute;
			bottom: -12px;
			left: 10px;
			width: 200px;
		}
		.icon {
			margin-right: 6px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 20px;
			height: 20px;
			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
		.name {
			margin-right: 6px;
			max-width: 300px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			font-size: 14px;

			font-weight: 400;
			color: #333333;
		}
		.size {
			font-size: 14px;

			font-weight: 400;
			color: #999999;
		}
		.remove:active {
			opacity: 0.8;
		}
		.remove {
			cursor: pointer;
			margin-left: 16px;
			font-size: 14px;

			font-weight: 400;
			color: #e60000;
			display: none;
		}
	}
	::v-deep .el-upload-list {
		display: none;
	}
	.download-small-btn:active,
	.download-small-btn:hover {
		border: 1px solid #e60000 !important;
		border-radius: 2px;
		color: #e60000 !important;
	}
	.submit-btn {
		background-color: #e60000;
	}
	.download-small-btn {
		border: 1px solid #e60000;
		border-radius: 2px;
		color: #e60000;
	}

	::v-deep {
		// 面包屑
		.el-breadcrumb__inner {
			font-size: 14px;

			font-weight: 400;
			color: #999999 !important;
			&:hover {
				color: $theme-color !important;
			}
		}
	}

	.span_red {
		color: $theme-color;
	}
</style>
